<script>
  import { format } from 'svelte-i18n';
  import { useNavigate } from 'svelte-navigator';
  import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from '@sveltestrap/sveltestrap';

  import { getNotificationsContext } from '@client/components/notifications';
  import { RuleBlock } from '@client/components/rule-block';

  import { PluginsService } from '@client/services/plugins';

  export let data = {};
  export let onRename = null;

  let active = false;
  let dropdownRef = null;
  let showUserMenu = false;
  let inactive = false;
  let copyRef = null;

  const { addNotification } = getNotificationsContext();

  const notify = (text, type = 'success', autohide = 2500, position = 'top-right') => {
    addNotification({ text, type, autohide, position });
  };

  const navigate = useNavigate();
  const redirect = (path) => navigate(path);

  const onClick = (e) => {
    const element = e.target;

    active = true;

    if (dropdownRef === element || dropdownRef?.contains(element) || copyRef?.contains(element)) {
      active = false;
    } else {
      navigate(`/manage/integrations/${data.rulename}`, {});
    }
  };

  const onMouseUp = () => {
    active = false;
  };

  const onDisablePlugin = async () => {
    data.status = false;

    const response = await PluginsService.savePlugin(data);

    if (response?.status >= 400) {
      notify($format('label.FAILURE.PLUGIN_CARD_DISABLE', { values: { rulename: data.rulename } }), 'error');

      return;
    }

    notify($format('label.SUCCESS.PLUGIN_CARD_DISABLE', { values: { rulename: data.rulename } }));
  };

  const onEnablePlugin = async () => {
    data.status = true;

    const response = await PluginsService.savePlugin(data);

    if (response?.status >= 400) {
      notify($format('label.FAILURE.PLUGIN_CARD_ENABLE', { values: { rulename: data.rulename } }), 'error');

      return;
    }

    notify($format('label.SUCCESS.PLUGIN_CARD_ENABLE', { values: { rulename: data.rulename } }));
  };

  const onDeletePlugin = async () => {
    const response = await PluginsService.deletePlugin(data);

    if (response?.status >= 400) {
      notify(
        $format('label.FAILURE.PLUGIN_CARD_DELETE', { values: { rulename: data.rulename, message: response.message } }),
        'error'
      );

      return;
    }

    notify($format('label.SUCCESS.DELETE', { values: { type: data.rulename } }));

    setTimeout(() => window.location.reload(), 250);
  };

  $: inactive = !data.status;
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
  class="plugin-card"
  class:active
  class:inactive
  role="button"
  tabindex="0"
  on:click={(e) => !inactive && onClick(e)}
  on:mouseleave={() => (showUserMenu = false)}
  on:mouseup={onMouseUp}
>
  <div bind:this={dropdownRef} class="action">
    <Dropdown isOpen={showUserMenu} toggle={() => (showUserMenu = !showUserMenu)}>
      <DropdownToggle tag="div" class="os-icon-more-horizontal" />
      <DropdownMenu>
        {#if onRename}
          <DropdownItem on:click={() => onRename(data)}>{$format('label.RENAME')}</DropdownItem>
          <DropdownItem divider />
        {/if}
        <DropdownItem on:click={() => redirect(`/manage/integrations/${data.rulename}`)}>
          {$format('label.EDIT')}
        </DropdownItem>
        <DropdownItem divider />
        {#if !inactive}
          <DropdownItem on:click={onDisablePlugin}>{$format('label.DISABLE')}</DropdownItem>
        {:else}
          <DropdownItem on:click={onEnablePlugin}>{$format('label.ENABLE')}</DropdownItem>
        {/if}
        <DropdownItem divider />
        <DropdownItem on:click={onDeletePlugin}>{$format('label.DELETE')}</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
  <div class="plugin">
    <div class="logo">
      <img
        src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
        style="background: url('https://assets.opensense.com/plugins/{!data.provider
          ? 'opensense'
          : data.provider}.svg') no-repeat center center; background-size: contain;"
        alt={data.provider}
        draggable="false"
      />
    </div>

    <div bind:this={copyRef}>
      <RuleBlock text="[[plugin:{data.rulename}]]" />
    </div>

    {#if inactive}
      <div class="inactive">{$format('label.DISABLED_PLUGIN')}</div>
    {/if}
    <!-- {JSON.stringify(data, null, 2)} -->
  </div>
</div>

<style lang="scss" src="./plugin-card.scss"></style>
